var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCont(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "9.1711pt",
    height: "2.4688pt",
    viewBox: "0 0 9.1711 2.4687",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", {
    id: "glyph-18-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.2812-2.0781c0.29688 0 0.48438 0.10938 0.57812 0.1875v-0.35938c-0.09375-0.078125-0.29688-0.14062-0.59375-0.14062-0.59375 0-1.0938 0.4375-1.0938 1.2031s0.5 1.2031 1.0938 1.2031c0.29688 0 0.5-0.0625 0.59375-0.14062v-0.35938c-0.09375 0.078125-0.28125 0.20312-0.57812 0.20312-0.40625 0-0.75-0.29688-0.75-0.90625s0.34375-0.89062 0.75-0.89062z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-18-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.2344-2.4219c-0.64062 0-1.0625 0.5-1.0625 1.2344s0.42188 1.2344 1.0625 1.2344c0.65625 0 1.0781-0.5 1.0781-1.2344s-0.42188-1.2344-1.0781-1.2344zm0 2.1719c-0.46875 0-0.70312-0.40625-0.70312-0.9375s0.23438-0.9375 0.70312-0.9375 0.71875 0.40625 0.71875 0.9375-0.25 0.9375-0.71875 0.9375z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-18-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.7812-2.3594v1.7656l-1.1406-1.7812h-0.32812v2.375h0.34375v-1.7812l1.125 1.7812h0.34375v-2.375h-0.34375z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-18-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.6719-2.375h-1.6406v0.28125h0.64062v2.0938h0.35938v-2.0938h0.64062z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-18-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.39062 0.015625c0.10938 0 0.20312-0.078125 0.20312-0.20312s-0.09375-0.20312-0.20312-0.20312c-0.125 0-0.20312 0.078125-0.20312 0.20312s0.078125 0.20312 0.20312 0.20312z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-458.78 -564.44)",
    fill: "#171817"
  }, /*#__PURE__*/React.createElement("use", {
    x: 458.60419,
    y: 566.85974,
    xlinkHref: "#glyph-18-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 460.67062,
    y: 566.85974,
    xlinkHref: "#glyph-18-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 463.21671,
    y: 566.85974,
    xlinkHref: "#glyph-18-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.72568,
    y: 566.85974,
    xlinkHref: "#glyph-18-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 467.35336,
    y: 566.85974,
    xlinkHref: "#glyph-18-11"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCont);
export default __webpack_public_path__ + "static/media/cont.aef65dfcf8e4cf672633a238b601471f.svg";
export { ForwardRef as ReactComponent };